module.exports = __webpack_public_path__ + "img/1.aa2d5d31.png";